import * as React from 'react'
import { motion } from 'framer-motion'
import { Box, SxProps } from '@mui/material'
import { useAnimationStyles } from 'src/Libs/live-view'
import EnergyFlowIndicatorSvg from './EnergyFlowIndicatorSvg'

export interface ArrowSvgProps {
  transform: string
  direction?: 'in' | 'out'
  doRotateBy180Deg?: boolean
  sx?: SxProps
}

const CurvedBottomArrowSvg: React.FC<ArrowSvgProps> = ({ direction, transform, doRotateBy180Deg = false, sx }) => {
  const { classes, cx } = useAnimationStyles({ direction })

  return (
    <Box sx={{ position: 'relative', transform, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="152" height="53" viewBox="0 0 152 53" fill="none">
        <g id="livevalue_arrows">
          <motion.g id="line">
            <motion.path
              id="Vector 8"
              d="M7.49754 51.0001L7.49754 30.1447C7.49754 21.8605 14.2133 15.1447 22.4975 15.1447L124.675 15.1447C128.443 15.1447 131.497 12.0903 131.497 8.32246V8.32246L131.497 1.50018"
              stroke="#A4AAAE"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </motion.g>
          {direction === 'in' && (
            <g id="arrow_in_curved_side_arrow">
              <path
                d="M124.29 6.79165L124.222 6.86692C123.901 7.2597 123.924 7.83968 124.29 8.20586C124.656 8.57205 125.236 8.59476 125.629 8.27423L125.704 8.20586L132.203 1.70725C132.594 1.31672 132.594 0.683559 132.203 0.293035C131.812 -0.0974894 131.179 -0.0974894 130.789 0.293035L124.29 6.79165Z"
                fill="#A4AAAE"
              />
              <path
                d="M137.291 8.20709L137.367 8.27615C137.76 8.59633 138.339 8.57315 138.705 8.2071C139.096 7.81657 139.096 7.18341 138.705 6.79288L132.205 0.292885C131.815 -0.0976391 131.181 -0.09764 130.791 0.292884C130.4 0.683408 130.4 1.31657 130.791 1.7071L137.291 8.20709Z"
                fill="#A4AAAE"
              />
            </g>
          )}
          {direction === 'out' && (
            <g id="arrow_out_curved_side_arrow">
              <path
                d="M14.7079 45.2085L14.7763 45.1332C15.0968 44.7404 15.0741 44.1604 14.7079 43.7943C14.3417 43.4281 13.7617 43.4054 13.369 43.7259L13.2937 43.7943L6.79507 50.2929C6.40455 50.6834 6.40455 51.3166 6.79507 51.7071C7.18559 52.0976 7.81876 52.0976 8.20928 51.7071L14.7079 45.2085Z"
                fill="#A4AAAE"
              />
              <path
                d="M1.70718 43.793L1.63123 43.724C1.23845 43.4038 0.659025 43.427 0.292971 43.793C-0.0975533 44.1835 -0.0975534 44.8167 0.292971 45.2072L6.79297 51.7072C7.18349 52.0978 7.81665 52.0978 8.20718 51.7072C8.5977 51.3167 8.5977 50.6835 8.20718 50.293L1.70718 43.793Z"
                fill="#A4AAAE"
              />
            </g>
          )}
        </g>
      </svg>
      {!!direction && (
        <EnergyFlowIndicatorSvg
          className={cx(classes.directionIndicator, classes.curvedSideArrowAnimation)}
          doRotateBy180Deg={doRotateBy180Deg}
          direction={direction}
        />
      )}
    </Box>
  )
}

export default CurvedBottomArrowSvg
